module.exports = __webpack_public_path__ + "img/金属材料学4_5.dfeadb67.png";